import React, { useRef, useEffect, useState } from "react";
import InputField from "../InputField";
import styled from "styled-components";
import { Colors } from "../../../config";
import { format } from "date-fns";
import { DateRangePicker } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import "./rangepicker.css";

const DateRangePickerInput = ({
  onDateSelection,
  label,
  start,
  end,
  minDate,
  maxDate,
  helperText,
  autoMinMaxSelect = true,
  disabled,
  required = false,
}) => {
  const wrapperRef = useRef(null);
  const [showOptions, setShowOptions] = useState(false);
  const [showEmpty, setShowEmpty] = useState(false);

  const [state, setState] = useState([
    {
      startDate: start
        ? new Date(start)
        : autoMinMaxSelect
          ? new Date(minDate)
          : new Date(),
      endDate: end
        ? new Date(end)
        : autoMinMaxSelect
          ? new Date(maxDate)
          : new Date(),
      key: "selection",
    },
  ]);

  const useClickOutside = (ref) => {
    useEffect(() => {
      const handleClickOutside = (event) => {
        if (ref.current && !ref.current.contains(event.target)) {
          setShowOptions(false);
        }
      };
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  };

  useClickOutside(wrapperRef);

  const handleShow = (e) => {
    e.preventDefault();
    setShowOptions(true);
  };

  const handleSelection = (item) => {
    setShowEmpty(false);
    setState([item.selection]);
    onDateSelection(item.selection.startDate, item.selection.endDate);

    if (
      item.selection.startDate.toString() !== item.selection.endDate.toString()
    ) {
      setShowOptions(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Backspace") {
      setShowEmpty(true);
      setState([
        {
          startDate: new Date(),
          endDate: new Date(Date.now() + 24 * 60 * 60 * 1000),
          key: "selection",
        },
      ]);
      onDateSelection("", "");
    }
  };

  const displayValue =
    showEmpty || (!start && !end)
      ? "Select Preferred Date"
      : `${format(state[0].startDate, "ccc dd-MM-yyyy")} - ${format(
          state[0].endDate,
          "ccc dd-MM-yyyy",
        )}`;

  return (
    <TravelClassSelectWrapper ref={wrapperRef}>
      <InputField
        label={label}
        value={displayValue}
        isRounded
        onFocus={handleShow}
        onKeyDown={handleKeyDown}
        helperText={helperText}
        disabled={disabled}
        required={required}
      />
      {showOptions && (
        <Options>
          <DateRangePicker
            onChange={(item) => handleSelection(item)}
            showSelectionPreview={false}
            moveRangeOnFirstSelection={false}
            months={2}
            ranges={state}
            direction="horizontal"
            preventSnapRefocus={false}
            calendarFocus="forwards"
            showMonthAndYearPickers={false}
            showDateDisplay={false}
            editableDateInputs={false}
            showPreview={false}
            color={Colors.pomegranate}
            rangeColors={[Colors.pomegranate]}
            minDate={minDate ? new Date(minDate) : undefined}
            maxDate={maxDate ? new Date(maxDate) : undefined}
          />
        </Options>
      )}
    </TravelClassSelectWrapper>
  );
};

const Options = styled.div`
  position: absolute;
  border-radius: 0.5rem;
  background: ${Colors.white};
  top: 4rem;
  left: -3rem;
  transform: scale(0.85);
  border: 1px solid ${Colors.sharkApproxOpacity40};
  display: flex;
  flex-direction: column;
  z-index: 9999;
  @media only screen and (max-width: 768px) {
    width: 100%;
    overflow: auto;
    left: 0;
  }
`;

const TravelClassSelectWrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
`;

export default DateRangePickerInput;
